import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../translations';
import { ReceptionServiceFormController } from '../ReceptionServiceForm';

export type ReceptionServiceNameValue = string;

type ReceptionServiceNameTextInputProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServiceNameTextInput = (props: ReceptionServiceNameTextInputProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
         maxLength: 150,
      };
   }, []);

   return (
      <TextInput
         testId={'name'}
         label={receptionServiceTranslationKeys.shared.form.components.nameTextInput.label}
         placeholder={receptionServiceTranslationKeys.shared.form.components.nameTextInput.placeholder}
         controller={props.register('name', validationRules)}
         disabled={props.disabled}
         defaultValue={null}
      />
   );
};
